import React from 'react'
import RFPModuleTemplate from './RFPModuleTemplate'

const TrackRFP = () => (
  <RFPModuleTemplate
    title="Track RFP"
    description="Track lifecycle progress from publish to response closure and final decision."
    features={[
      'RFP pipeline cards by stage',
      'Response progress and deadline monitor',
      'KPI widgets for participation and completion'
    ]}
  />
)

export default TrackRFP
